"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMatchFactorDescriptionDrawer = void 0;

var _baseReactComponents = require("@navinc/base-react-components");

var _matchFactorDescription = require("./match-factor-description");

var _jsxRuntime = require("react/jsx-runtime");

var useMatchFactorDescriptionDrawer = function useMatchFactorDescriptionDrawer() {
  var _useInfoDrawer = (0, _baseReactComponents.useInfoDrawer)(),
      setInfoDrawer = _useInfoDrawer.setInfoDrawer;

  var showMatchFactorDescriptionDrawer = function showMatchFactorDescriptionDrawer() {
    return setInfoDrawer({
      isOpen: true,
      title: 'About Nav’s MatchFactor',
      content: /*#__PURE__*/(0, _jsxRuntime.jsx)(_matchFactorDescription.MatchFactorDescription, {})
    });
  };

  return showMatchFactorDescriptionDrawer;
};

exports.useMatchFactorDescriptionDrawer = useMatchFactorDescriptionDrawer;
//# sourceMappingURL=use-match-factor-description-drawer.js.map